import { render, staticRenderFns } from "./RatingClassificationSelector.vue?vue&type=template&id=4999986e&scoped=true&"
import script from "./RatingClassificationSelector.vue?vue&type=script&lang=js&"
export * from "./RatingClassificationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999986e",
  null
  
)

export default component.exports